import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { lockPublicWebScroll } from './scrollLock';

export default function PublicWebDialog({ open, onClose, title, children, className = '', labelledBy = 'ca-web-dialog-title' }) {
  const ref = useRef(null);
  const close = useRef(onClose); close.current = onClose;
  useEffect(() => {
    if (!open) return;
    const dialog = ref.current, previous = document.activeElement;
    const unlock = lockPublicWebScroll();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    const cancel = event => { event.preventDefault(); close.current(); };
    dialog.addEventListener('cancel', cancel);
    return () => {
      dialog.removeEventListener('cancel', cancel);
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
      unlock();
      if (previous?.isConnected) previous.focus?.();
    };
  }, [open]);
  return <dialog ref={ref} className={className} aria-labelledby={labelledBy} onClick={event => {
    if (event.target !== ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) onClose();
  }}>
    <div className="dialog-header"><h2 id={labelledBy}>{title}</h2><button className="icon-button" type="button" onClick={onClose} aria-label="Cerrar ventana"><X className="icon" aria-hidden="true" /></button></div>
    {children}
  </dialog>;
}
